import React from 'react'
import Head from 'next/head'

import BasePage from 'modules/marketplace/layout/components/BasePage'
import { SlimContainer } from 'modules/marketplace/layout/components/ResponsiveContainers'

// TODO: add getStaticProps for static rendering
const ContactPage = () => (
  <BasePage hasMarketingFooter>
    <Head>
      <title>Contact · Fieldfolio</title>
      <link rel="canonical" href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/contact`} />
    </Head>

    <SlimContainer>
      <section style={{ padding: '6rem 0 3rem 0' }}>
        <h1 className="headline">Thinking about signing up?</h1>
        <p className="subhead">Contact sales.</p>
        <p>Our sales team is available 9am to 5pm AEST, Monday to Friday.</p>
        <ul className="linklist">
          <li>
            <a href="mailto: sales@fieldfolio.com">sales@fieldfolio.com</a>
          </li>
        </ul>
      </section>

      <section style={{ padding: '3rem 0 6rem 0' }}>
        <h1 className="headline">Looking for help?</h1>
        <p className="subhead">Search our help articles or email support.</p>
        <ul className="linklist">
          <li>
            <a target="_blank" rel="noopener noreferrer" href={`${process.env.NEXT_PUBLIC_HELP_URL}`}>
              FAQ, Docs and Guides
            </a>
          </li>
          <li>
            <a href="mailto: support@fieldfolio.com">support@fieldfolio.com</a>
          </li>
        </ul>
      </section>
    </SlimContainer>
  </BasePage>
)

export default ContactPage
